import type { FunctionComponent } from 'react';

import TrayIcon from '@atlaskit/icon/glyph/tray';

import styles from './StubInbox.less';

export const StubInbox: FunctionComponent = () => {
  return (
    <header className={styles.header}>
      <TrayIcon label="" size="medium" />
      <span>Inbox</span>
    </header>
  );
};
